import { useApi } from '@hooks/useApi';
import { useQuery } from '@tanstack/react-query';
import { queryKeys } from '@utils/consts';
import { StaffUser } from '@root/globalTypes';

type GetUsersReturn = {
  data: StaffUser[];
  isPending: boolean;
};

export function useList(): GetUsersReturn {
  const { query } = useApi();

  const { data, isPending } = useQuery<StaffUser[]>({
    queryKey: [...queryKeys.staffUsers, window.location.search],
    queryFn: (): Promise<StaffUser[]> =>
      query({
        path: `v1/staff/users${window.location.search}`,
      }),
  });

  return {
    data: data || [],
    isPending,
  };
}
